import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const RebuildAllButton = () => {
  const [job, setJob] = useState({ status: "idle" });
  const timer = useRef(null);

  const poll = () => {
    clearInterval(timer.current);
    timer.current = setInterval(async () => {
      let r;
      try {
        r = await api.get("/rebuild-all");
      } catch {
        return;
      }
      setJob(r.data);
      if (r.data.status !== "running") {
        clearInterval(timer.current);
        if (r.data.status === "done") toast.success(`Rebuilt ${r.data.done - (r.data.failed?.length || 0)} of ${r.data.total} titles`);
        if (r.data.failed?.length) toast.error(`${r.data.failed.length} title(s) could not be rebuilt`);
      }
    }, 3000);
  };

  useEffect(() => {
    api.get("/rebuild-all").then((r) => {
      setJob(r.data);
      if (r.data.status === "running") poll();
    });
    return () => clearInterval(timer.current);
  }, []);

  const start = async () => {
    if (!window.confirm("Rebuild the PDF, toolkit and sample of every title with its current colours and logo?")) return;
    try {
      await api.post("/rebuild-all");
      setJob({ status: "running", done: 0, total: 0 });
      poll();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const running = job.status === "running";
  return (
    <Button variant="outline" onClick={start} disabled={running} className="rounded-none gap-2 bg-transparent" data-testid="rebuild-all-btn">
      <RefreshCw size={15} className={running ? "animate-spin" : ""} />
      {running ? `Rebuilding ${job.done || 0} of ${job.total || "…"}` : "Rebuild all files"}
    </Button>
  );
};
